import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion";

import { getRandomJokes } from "shared/api/jokes";
import { logoVariants } from "shared/components/animations";
import guesserText from "assets/images/tot/guesser.png";
import clueGiverText from "assets/images/tot/clue-giver.png";
import TOTJoining from "./screens/TOTJoining";
import TOTPreGuess from "./screens/TOTPreGuess";
import TOTGuessing from "./screens/TOTGuessing";
import TOTResultRound from "./screens/TOTResultRound";
import TOTCategoriesModal from "./components/TOTCategoriesModal";
import CategoryWarningModal from "./components/CategoryWarningModal";

const TOT = () => {
  const {
    gameReducer: {
      currentUser,
      roomObj: {
        id: roomId,
        users,
        game_state: {
          word,
          status,
          right_words,
          skipped_words,
          active_player,
          category_image,
          current_category
        } = {}
      }
    },
    paramsReducer
  } = useSelector((state) => state);

  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );
  const currentGuesser = users?.find(
    (user) => user.player_id === active_player
  );
  const isGuesser = currentPlayer?.player_id === active_player;

  const categories = _.get({}, "categories", [
    "Sports",
    "Celebrities",
    "Musical Theater",
    "Disney",
    "Entertainment",
    "Everyday Life",
    "Travel",
    "Fun and Games",
    "Food and Drink",
    "Science and Technology",
    "Philosophy, Fables, Myths, and Legends",
    "Back in the Day"
  ]);

  const [categoriesModal, setCategoriesModal] = useState({
    isOpen: false,
    category: ""
  });
  const [warningModal, setWarningModal] = useState(false);
  const [joke, setJoke] = useState("");

  const toggleWarningModal = () => {
    setWarningModal((prev) => !prev);
  };

  const toggleCategoriesModal = (value) => {
    setCategoriesModal((prev) => ({ ...prev, isOpen: value }));
  };

  const handleCategorySelect = (category) => {
    setCategoriesModal((prev) => ({ ...prev, category: category }));
  };

  const showTopText = () => {
    return (
      status === "PreGuess" || status === "Guessing" || status === "ResultRound"
    );
  };

  useEffect(() => {
    getRandomJokes().then((data) => setJoke(data));
  }, []);

  const getExitValue = () => (status === "ResultRound" ? "exit" : "");

  return (
    <div className="tot-wrapper">
      <AnimatePresence exitBeforeEnter>
        {showTopText() && (
          <motion.div
            variants={logoVariants}
            initial="hidden"
            animate="visible"
            exit={getExitValue()}
            className="tot-top-text"
          >
            <img
              alt=""
              src={isGuesser ? guesserText : clueGiverText}
              className=""
            />
          </motion.div>
        )}
      </AnimatePresence>

      <div className={`tot-content ${showTopText() ? "with-top-text" : ""}`}>
        <AnimatePresence exitBeforeEnter>
          {status === "Joining" && <TOTJoining key="tot_1" users={users} />}
          {status === "PreGuess" && (
            <TOTPreGuess
              key="tot_2"
              roomId={roomId}
              isGuesser={isGuesser}
              currentGuesser={currentGuesser}
              category={categoriesModal.category}
              onOpenWarningModal={toggleWarningModal}
              onModalOpen={() => toggleCategoriesModal(true)}
            />
          )}
          {status === "Guessing" && (
            <TOTGuessing
              key="tot_3"
              word={word}
              roomId={roomId}
              isGuesser={isGuesser}
              right_words={right_words}
              skipped_words={skipped_words}
              category_image={category_image}
              currentGuesser={currentGuesser}
              current_category={current_category}
            />
          )}
          {status === "ResultRound" && (
            <TOTResultRound
              key="tot_4"
              joke={joke}
              word={word}
              roomId={roomId}
              isGuesser={isGuesser}
            />
          )}
          {status === "Over" && (
            <TOTJoining key="tot_5" users={users} isOver={true} />
          )}
        </AnimatePresence>
      </div>

      {categoriesModal.isOpen && (
        <TOTCategoriesModal
          categories={categories}
          setCategory={handleCategorySelect}
          onClose={() => toggleCategoriesModal(false)}
        />
      )}
      {warningModal && <CategoryWarningModal onClose={toggleWarningModal} />}
    </div>
  );
};

export default TOT;
